module.exports = __webpack_public_path__ + "img/icon_my_male_2.dab571ab.png";